import { useState, useEffect } from 'react';
import { serialize, parse } from 'cookie';
const DEFAULT_DOMAIN = '.telus.com';
export default function useLocale() {
    const [{ lang: stateLang, prov: stateProv }, setLocaleCookies] = useState({
        lang: '',
        prov: ''
    });
    const setLocale = ({ lang = stateLang, prov = stateProv }, opts = {}) => {
        setLocaleCookies({ lang, prov });
        const { domain = DEFAULT_DOMAIN } = opts;
        const cookieOptions = Object.assign(Object.assign({}, opts), { domain });
        // read on how to use document.cookie here -> https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
        document.cookie = serialize('lang', lang !== null && lang !== void 0 ? lang : '', cookieOptions);
        document.cookie = serialize('prov', prov !== null && prov !== void 0 ? prov : '', cookieOptions);
    };
    useEffect(() => {
        const { lang, prov } = parse(document.cookie);
        setLocaleCookies({ lang, prov });
    }, []);
    return [{ lang: stateLang, prov: stateProv }, setLocale];
}
